var canvas, canvas2, text, newText, zoom, cWidth = 1200, cHeight = 800,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data,scale_factor, newheight, leftOb,fontFamily, imageUrl, img;

var loader = jQuery('#customLoader'),
    boxWidth, boxLeft, boxTop, frontShirt, backShirt, thumb,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 600, sizeB1H = 600,
    sizeB2W = 600, sizeB2H = 600;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');

/* Page 2 canvas */
window['canvas2'] = new fabric.Canvas('canvas2',{
  width:cWidth,
  height:cHeight,
  selection: false
});
addModify(window['canvas2']);

let Brown_Panda_Bear = document.querySelector("#Brown_Panda_Bear");
let BrownPandaBear = new fabric.Image(Brown_Panda_Bear, {
  left: 650,   
  top: 250,
  scaleX: 0.3, // or adjust based on desired size
  scaleY: 0.3
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: 240,
  height: 240
});



let White_Panda_Bear = document.querySelector("#White_Panda_Bear");
let WhitePandaBear = new fabric.Image(White_Panda_Bear, {
  left: 245,   
  top: 255,
  scaleX: 0.295,
  scaleY: 0.295
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: 240,
  height: 240
});

window['canvas2'].add(BrownPandaBear);
window['canvas2'].add(WhitePandaBear);

addModify(window['canvas2']);


var hubbyMugColor = jQuery('input[name="Husband Mug Color"]:checked').val();
url = jQuery('#Husband_mug_color a[data-title="'+hubbyMugColor+'"] img').attr('data-src');

function updatefrontShirtImage(){
  var hubbyMugColor = $('input[name="Husband Mug Color"]:checked').val();
  var url = $('#Husband_mug_color a[data-title="' + hubbyMugColor + '"] img').attr('data-src');
  if (window['frontShirt']){
    canvas2.remove(window['frontShirt']);
  }
  if(url){
    fabric.Image.fromURL(url, function(img){
      window['frontShirt'] = img;
      window['frontShirt'].set({
        id: 'frontShirt',
        left: 310,
        top: halfHeight
      });
      window['frontShirt'].scaleToWidth(sizeB1W);
      canvas2.add(window['frontShirt']);
      window['frontShirt'].sendToBack();
      canvas2.renderAll();
    });
  }
}

$(document).on('change', 'input[name="Husband Mug Color"]', function () {
    var hubbyMugColor = $(this).val();
    setTimeout(function () {
        updatefrontShirtImage(hubbyMugColor);
    }, 100); 
});

updatefrontShirtImage();

var wifeMugColor = jQuery('input[name="Wife Mug Color"]:checked').val();
url = jQuery('#Wife_mug_color a[data-title="'+wifeMugColor+'"] img').attr('data-src');

function updatebackShirtImage(){
  var wifeMugColor = $('input[name="Wife Mug Color"]:checked').val();
  var url = $('#Wife_mug_color a[data-title="' + wifeMugColor + '"] img').attr('data-src');
  if (window['backShirt']){
    canvas2.remove(window['backShirt']);
  }
  if(url){
    fabric.Image.fromURL(url, function(img){
      window['backShirt'] = img;
      window['backShirt'].set({
        id: 'backShirt',
        left: 880,
        top: halfHeight
      });
      window['backShirt'].scaleToWidth(sizeB2W);
      canvas2.add(window['backShirt']);
      window['backShirt'].sendToBack();
      canvas2.renderAll();
    });
  }
}

$(document).on('change', 'input[name="Wife Mug Color"]', function () {
    var wifeMugColor = $(this).val();
    setTimeout(function () {
        updatebackShirtImage(wifeMugColor);
    }, 100); 
});

updatebackShirtImage();


var thumbChoice = jQuery('#thumbChoice').text(),
    shirtShade, imgURL, fontShade;

var currentImage = null;


var Left, Top, ScaleX, ScaleY, Opacity;
function updateColorShirt(md,imageSRC){
  canvas2.getObjects().forEach((obj) => {
    if(obj.id == md){
      Left = window[md].left;
      Top = window[md].top;
      ScaleX = window[md].scaleX;
      ScaleY = window[md].scaleY;
      Opacity = window[md].opacity;
      canvas2.remove(window[md]);
      fabric.Image.fromURL(imageSRC, function(img){
        window[md] = img;
        window[md].set({
          id: md,
          left: Left,
          top: Top,
          scaleX: ScaleX,
          scaleY: ScaleY,
          opacity: Opacity
        });
        // img.scaleToWidth(sizeB1W);
        canvas2.add(window[md]);
        if(md == 'backShirt'){
          window[md].sendToBack();
        }
        canvas2.renderAll();
      });
    }
  });
}

function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
    // loadFirstImg();
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


function showExtras(canvas){
  canvas.getObjects().forEach((obj) => {
    if(obj.id == 'backShirt' || obj.id == 'frontShirt'){
      obj.set('opacity',1);
    }
    canvas.renderAll();
  });
}

function hideExtras(canvas){
  canvas.getObjects().forEach((obj) => {
    if(obj.id == 'backShirt' || obj.id == 'frontShirt'){
      obj.set('opacity',0);
    }
    canvas.renderAll();
  });
}

/* fetch Call */
var size,options,optC,optS,fSide,bSide;
var loadedObject,wMark,svgMrk,additionalInfo;
var do_frnt,do_back,temp_front,temp_back,orig_front,orig_back;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    additionalInfo = jQuery('.tShirtImg textarea').val();
    fSide = 1;
    bSide = 1;
    resizeObjects(window['canvas2']);
    const canvasIDs = ['frontS', 'backS'];
    canvasIDs.forEach((id, index) =>{
      const canvas = window['canvas2'];
      size = 350;
      loadMark(id,canvas,size);
      size = 4000;
      removeMark(id,canvas,size);
      if(index > 0 && index < 3){
        hideExtras(canvas);
      }
      window[id] = canvas.toDataURL('image/png');
      console.log(window[id]);
      if(index > 0 && index < 3){
        showExtras(canvas);
      }
      canvasBlock(canvas);
    });

    fetch('//technology-architects.com/tasweer-modules/save_2shirts.php',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      do_frnt: fSide,
      do_back: bSide,
      temp_front: window['frontSt'],
      orig_front: window['frontS'],
      temp__back: window['backSt'],
      orign_back: window['backS'],
    })
  })
  .then(response => response.json())
  .then(data => {
    var prId = data[0],
        fImg = data[1],
        bImg = data[2];
    console.log(prId);
    console.log(fImg);
    console.log(bImg);
    
    /*if(bSide>0){
      optS = optC[1];
    }
    jQuery('input.product-variant-id[name="id"]').val(optS);*/
    jQuery('#previewImg').val(prId);
    jQuery('#addInfo').val(additionalInfo);
    if(fImg){
      jQuery('.sides_preView').append('<input type="hidden" id="pfExtraImg" name="properties[frnt_image]" value="' + fImg + '">');
      new fabric.Group([WhitePandaBear]);
    }
    if(bImg){
      jQuery('.sides_preView').append('<input type="hidden" id="pbExtraImg" name="properties[back_image]" value="' + bImg + '">');
      new fabric.Group([BrownPandaBear]);
    }
    jQuery('.canvas_div').show();
    setTimeout(function(){
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      loader.addClass('hidden');
    },100);
  })
  .catch(error => console.error('Error uploading images:', error));
  },100);
});


function resizeObjects(canvas){
  fSide = new fabric.Group([WhitePandaBear]);
  bSide = new fabric.Group([BrownPandaBear]);
  window['backShirt'].set('opacity',0);
  window['frontShirt'].set('opacity',0);
  fSide.set({
    left: cWidth / 2,
    top: cHeight / 2,
    originX: 'center',
    originY: 'center'
  });
  fSide.scaleToWidth('700');
  bSide.set({
    left: cWidth / 2,
    top: cHeight / 2,
    originX: 'center',
    originY: 'center'
  });
  bSide.scaleToWidth('700');
  canvas.renderAll();
}

function loadMark(id,canvas,size){
  if(id === 'frontS'){
    fSide.set({opacity:1});
    bSide.set({opacity:0});
  }else{
    bSide.set({opacity:1});
    fSide.set({opacity:0});
  }
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(id,canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}